import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { UICopyButton, UIFormSectionCard } from "../../../../ui";
import SummaryRow from "./SummaryRow";

const ROWS = [
  { key: "bank_name", labelKey: "bankName" },
  { key: "account_name", labelKey: "accountName" },
  { key: "iban", labelKey: "iban", copyable: true },
  { key: "account_number", labelKey: "accountNumber", copyable: true },
  { key: "swift_code", labelKey: "swiftCode" },
];

const BankTransferDetails = ({ t, details, compact }) => {
  const rows = ROWS.map(({ key, labelKey, copyable }) => (
    <SummaryRow key={key} label={t[labelKey]}>
      <span className="publish-pay-step__bank-value">
        <bdi dir="ltr">{details[key]}</bdi>
        {copyable && !compact && details[key] && (
          <UICopyButton
            className="publish-pay-step__copy"
            value={details[key]}
            ariaLabel={t.copy.replace("{field}", t[labelKey])}
            successMessage={t.copied.replace("{field}", t[labelKey])}
          />
        )}
      </span>
    </SummaryRow>
  ));

  if (compact) {
    return (
      <section className="publish-pay-step__bank">
        <Typography component="h3" className="text-label-md publish-pay-step__bank-title">
          {t.bankTransferDetails}
        </Typography>
        <div className="publish-pay-step__bank-card">{rows}</div>
      </section>
    );
  }

  return (
    <UIFormSectionCard
      title={t.bankTransferDetails}
      className="publish-pay-step__card publish-pay-step__card--rows"
    >
      {rows}
    </UIFormSectionCard>
  );
};

BankTransferDetails.propTypes = {
  t: PropTypes.object.isRequired,
  details: PropTypes.shape({
    bank_name: PropTypes.string,
    account_name: PropTypes.string,
    iban: PropTypes.string,
    account_number: PropTypes.string,
    swift_code: PropTypes.string,
  }).isRequired,
  /** Popup layout: title above a plain subtle card, no copy buttons. */
  compact: PropTypes.bool,
};

BankTransferDetails.defaultProps = {
  compact: false,
};

export default BankTransferDetails;
